import { defineMessage, useIntl } from 'react-intl';

import { WishlistSkusDocument } from '@packages/gql/generated/shopping/WishlistSkusDocument';
import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';

import { useBadgeCount } from './useBadgeCount';

const title = defineMessage({
  id: 'slot.wishlist.label',
  defaultMessage: 'Merkzettel',
});

export const useWishlistLink = () => {
  const { formatMessage } = useIntl();
  const { order } = useConfig();
  const { locale } = useI18n();

  const { badgeCount } = useBadgeCount({
    document: WishlistSkusDocument,
    getCount: (data) => data?.wishlist?.count ?? 0,
    eventNameForExternalUpdates: 'wishlistUpdated',
  });

  return {
    href: getLocalizedPath(order.paths.wishlist, locale),
    label: formatMessage(title),
    badgeCount,
  };
};
